export const CrudFunctions = (setCostingTableData, setReload, maxValue, productData) => {
  const handleAddRow = key => {
    let objectData;
    if (key === 'CostingMaterial') {
      objectData = {
        prdcd: productData?.ProductCode,
        productid: String(productData?.id),
        chiefmaterial: '',
        component:'',
        remark: '',
        unit: 'pcs',
        wgtqty: 0,
        materialrate: 0,
        batta: 0,
        totalmaterialcost: 0
      };
    } else if (key === 'CostingWood') {
      objectData = {
        prdcd: productData?.ProductCode,
        prdid: String(productData?.id),
        woodmaterial: '',
        component: '',
        remark: '',
        R_L: 0,
        R_W: 0,
        R_T: 0,
        R_Unit: 'Inch',
        F_L: 0,
        F_W: 0,
        F_T: 0,
        F_Unit: 'Inch',
        pcs: 1,
        cft: 0,
        rate: 0,
        amount: 0
      };
    } else if (key === 'CostingProcess') {
      objectData = {
        prdcd: productData?.ProductCode,
        prdid: String(productData?.id),
        Process: '',
        ProcessTyp: '',
        size: +maxValue,
        prcsrate: 0,
        prcsamt: 0
      };
    } else if (key === 'CostingAccessory') {
      objectData = {
        prdcd: productData?.ProductCode,
        prdid: String(productData?.id),
        materialname: '',
        matcost: 0,
        uom: '',
        qty: 0,
        amount: 0
      };
    } else if (key === 'Costingpacking') {
      objectData = {
        prdcd: productData?.ProductCode,
        prdid: String(productData?.id),
        packingmaterial: '',
        packingcost: 0,
        uom: ''
      };
    }

    setCostingTableData(prev => ({
      ...prev,
      [key]: [...prev[key], objectData]
    }));
  };

  const handleDeleteRow = (key, index) => {
    setCostingTableData(prev => {
      const updatedTableData = prev[key].filter((_, rowIndex) => rowIndex != index);
      return { ...prev, [key]: updatedTableData };
    });
    setReload(prev => !prev);
  };

  const handleChange = (key, value, name, index, subName = null) => {
    setCostingTableData(prev => {
      const newState = { ...prev };

      if (name === 'init') {
        // Directly initialize the array
        newState[key] = value;
      } else if (!subName) {
        // Update specific field
        if (Number(value) || value == 0) {
          newState[key][index][name] = +value;
        } else {
          // console.log('key', key);
          // console.log('index', index);
          // console.log('name', name);
          // console.log('value', value);
          newState[key][index][name] = value || '';
        }
      } else {
        // Update nested field
        newState[key][index][name][subName] = value?.trim();
      }

      return newState;
    });
  };

  return { handleAddRow, handleDeleteRow, handleChange };
};

export const cbmFunction = (rowData, pc) => {
  const L = rowData.R_L;
  const W = rowData.R_W;
  const T = rowData.R_T;
  const U = rowData.R_Unit;
  let CFT;
  if (L && W && T && U == 'Cm' && pc) {
    CFT =
      parseFloat(L) *
      0.0328084 *
      (parseFloat(W) * 0.0328084) *
      (parseFloat(T) * 0.0328084) *
      Number(pc);
    return CFT.toFixed(4);
  } else if (L && W && T && U == 'Inch' && pc) {
    CFT = ((parseFloat(L) * parseFloat(W) * parseFloat(T)) / 1728) * Number(pc);
    return CFT.toFixed(4);
  } else if (L && W && T && U == 'Mm' && pc) {
    CFT =
      parseFloat(L) *
      0.00328084 *
      (parseFloat(W) * 0.00328084) *
      (parseFloat(T) * 0.00328084) *
      Number(pc);
    return CFT.toFixed(4);

  } else {
    return null;
  }
};


